import { Component, HostListener, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';

import { TopbarService } from '../../services/topbar.service';
import { UtilityFunctions } from '../../utilities/functions.models';

@Component({
  standalone: false,
  selector: 'bt-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnDestroy {

  public showUserMenu: boolean;
  public titleData: { title: string, placeholder: string };
  public searchInputId = UtilityFunctions.newGuid();
  public searchText: { parent: string; child: string } = { parent: '', child: '' };
  public userName: string;

  private subscription = new Subscription();

  constructor(
    private service: TopbarService,
    private appService: AppService
  ) {
    this.titleSubscribe();
    this.userName = this.appService.user.userFirstName + ' ' + this.appService.user.userLastName;
  }

  @HostListener('window:keyup', ['$event'])
  public keyUpEvent(ev: KeyboardEvent) {
    if (ev.keyCode === 13 && document.activeElement.id === this.searchInputId) {
      this.onSearch();
    }
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public onSearch() {
    this.searchText.child = this.searchText.parent;
    this.service.nextSearchText(this.searchText.child);
  }

  public onClearSearch() {
    this.searchText.parent = '';
    this.onSearch();
  }

  public onBlurSearch() {
    if (!this.searchText.parent && this.searchText.child) {
      this.onSearch();
    }
  }

  private titleSubscribe() {
    this.subscription.add(this.service.topbarTitleSubscribe.subscribe(data => {
      this.searchText.child = '';
      this.searchText.parent = '';
      this.titleData = data;
    }));
  }
}
